import React from 'react';
import ProfileFormRow from './ProfileFormRow';
import { Contact } from '~/types/models';

export type ProfileFormErrors = Partial<Record<keyof Contact, string>>;

export interface ProfileFormProps {
  onProfileChange: (profileKey: string, value: string) => void;
  profile: Contact | null;
  errors?: ProfileFormErrors;
}

export default function ProfileForm({
  onProfileChange,
  profile,
  errors,
}: ProfileFormProps) {
  const rows = [
    {
      prop: 'name',
      placeholder: 'Name',
      label: 'Name *',
    },
    {
      prop: 'email',
      placeholder: 'email@email.com',
      label: 'Email',
    },
    {
      prop: 'position',
      placeholder: 'eg. CEO@Bonjoro',
      label: 'Official position',
    },
  ];
  return (
    <div className='w-80'>
      {rows.map((row) => {
        const prop = row.prop as keyof Contact;
        return (
          <ProfileFormRow
            {...row}
            profileKey={row.prop}
            key={prop}
            prop={prop}
            onChange={onProfileChange}
            profile={profile}
            errorMessage={errors?.[prop]}
          />
        );
      })}
    </div>
  );
}
